import SMFormModal from './SMFormModal';
export default SMFormModal;